/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLazyQuery } from '@apollo/client'
import { CircularProgress, Collapse, Paper } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { CHANNEL_INVENTORY_QUERY } from '../../graphql/Inventory'
import { DateObject } from '../../helpers/date'
import { Channel } from '../../types/channel'
import {
  RoomTypeForInventory,
  ChannelInventoryData,
  RatePlanForInventory,
  ProviderForInventory,
  GetInventoryInput,
  MenuItemInInventory
} from '../../types/inventory'
import InventoryProviderRow from './InventoryProviderRow'
import InventoryRatePlanRow from './InventoryRateplanRow'
import InventoryRatePlanSelectionModal from './InventoryRateplanSelectionModal'
import InventoryRoomtypeRow from './InventoryRoomtypeRow'
import { percentIncreaseDecreaseRegex } from './renderRows/RenderInputRowCell'
import useStyles from './styles/InventoryProviderBox'

interface InventoryProviderBoxProps {
  roomtypeCode: string
  numberOfRooms: number
  defaultOccupancy: number
  providerData: ProviderForInventory
  weekendIndexes: number[]
  channels: Channel[]
  occupancy: number | 'def'
  hideZeroes: boolean
  range: 'TWO_WEEKS' | 'MONTH'
  selectedInventoryFieldInProvider: MenuItemInInventory
  handleChangeSelectedInventoryFieldInProvider: (
    fieldType: MenuItemInInventory
  ) => void
  getInventoryInput: GetInventoryInput
  refreshInventory: () => void

  // onSaveRoomData: (providerData: SingleRoomTypeData) => void
  // ChannelInventory:
  //   | {
  //       channelInventory: ChannelInventoryData
  //     }
  //   | undefined
}

const PAGE_SIZE = 10

const InventoryProviderBox: React.FC<InventoryProviderBoxProps> = ({
  numberOfRooms,
  defaultOccupancy,
  roomtypeCode,
  providerData,
  weekendIndexes,
  channels,
  occupancy,
  hideZeroes,
  range,
  handleChangeSelectedInventoryFieldInProvider,
  selectedInventoryFieldInProvider,
  getInventoryInput,
  refreshInventory

  // ChannelInventory
  // onSaveRoomData
}) => {
  const classes = useStyles()
  const [
    selectedInventoryFieldInRatePlan,
    setselectedInventoryFieldInRatePlan
  ] = useState<MenuItemInInventory>({
    label: 'price',
    code: 'price',
    type: 'price'
  })
  const [selectedInventoryFieldInChannel, setselectedInventoryFieldInChannel] =
    useState<MenuItemInInventory>({
      label: 'price',
      code: 'price',
      type: 'price'
    })
  // const [ratePlanSelectionModalIsOpen, setratePlanSelectionModalIsOpen] =
  //   useState(false)

  const [showRatePlans, setshowRatePlans] = useState(false)

  const [numberOfVisibleRatePlans, setnumberOfVisibleRatePlans] =
    useState(PAGE_SIZE)
  // const [selectedRatePlanIndex, setselectedRatePlanIndex] = useState<number>(-1)
  const [
    getChannelInventoryData,
    { data: channelInventoryData, loading: channelInventoryLoading }
  ] = useLazyQuery<{
    channelInventory: ChannelInventoryData[]
  }>(CHANNEL_INVENTORY_QUERY, {
    fetchPolicy: 'network-only'
  })
  const handleChangeSelectedInventoryFieldInRatePlan = (
    fieldType: MenuItemInInventory
  ) => {
    setselectedInventoryFieldInRatePlan(fieldType)

    // if (
    //   Object.keys(providerData.rateplans[0].channels[0]).includes(
    //     fieldType as string
    //   )
    // ) {
    //   setselectedInventoryFieldInChannel(
    //     fieldType as InventoryChannelFieldsType
    //   )
    // }
  }

  const handleChangeSelectedInventoryFieldInChannel = (
    fieldType: MenuItemInInventory
  ) => {
    setselectedInventoryFieldInChannel(fieldType)
    // if (Object.keys(providerData.rateplans[0]).includes(fieldType as string)) {
    //   setselectedInventoryFieldInRatePlan(
    //     fieldType as InventoryRatePlanFieldsType
    //   )
    // }
  }

  // const handleChangeRatePlanRowData = (
  //   ratePlanNewRowData: InventoryRateplanType,
  //   index: number
  // ) => {
  //   const newRatePlansRowsData = providerData.rateplans
  //   newRatePlansRowsData[index] = ratePlanNewRowData
  //   onSaveRoomData({
  //     ...providerData,
  //     rateplans: newRatePlansRowsData
  //   })
  // }

  // const handleCopyRatePlanRowForOtherRatePlans = (
  //   index: number,
  //   selectedRatePlans: string[]
  // ) => {
  //   const newRoomData = providerData
  //   for (let i = 0; i < newRoomData.rateplans.length; i += 1) {
  //     if (
  //       i === index ||
  //       !selectedRatePlans.includes(newRoomData.rateplans[i].name)
  //     ) {
  //       // eslint-disable-next-line no-continue
  //       continue
  //     }
  //     for (
  //       let j = 0;
  //       j < newRoomData.rateplans[i][selectedInventoryFieldInRatePlan].length;
  //       j += 1
  //     ) {
  //       if (
  //         selectedInventoryFieldInRatePlan !== 'name' &&
  //         selectedInventoryFieldInRatePlan !== 'channels' &&
  //         newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //           .edited
  //       ) {
  //         const regexEdited =
  //           newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //             .editedValue &&
  //           percentIncreaseDecreaseRegex.test(
  //             newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //               .editedValue || ''
  //           )
  //         let newValue =
  //           newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][j]
  //             .value

  //         if (regexEdited) {
  //           newValue =
  //             (newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j]
  //               .value as number) +
  //             (newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j]
  //               .value as number) *
  //               (Number(
  //                 newRoomData.rateplans[index][
  //                   selectedInventoryFieldInRatePlan
  //                 ][j].editedValue!.substring(
  //                   1,
  //                   newRoomData.rateplans[index][
  //                     selectedInventoryFieldInRatePlan
  //                   ][j].editedValue!.length - 1
  //                 )
  //               ) /
  //                 100) *
  //               (newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][
  //                 j
  //               ].editedValue!.charAt(0) === '+'
  //                 ? 1
  //                 : -1)
  //         }
  //         newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j] = {
  //           ...newRoomData.rateplans[i][selectedInventoryFieldInRatePlan][j],
  //           edited: true,
  //           value: newValue,
  //           // eslint-disable-next-line no-nested-ternary
  //           editedValue: regexEdited
  //             ? newRoomData.rateplans[index][selectedInventoryFieldInRatePlan][
  //                 j
  //               ].editedValue
  //             : typeof newValue === 'boolean'
  //             ? undefined
  //             : newValue.toString()
  //         }
  //       }
  //     }
  //   }
  //   onSaveRoomData({
  //     ...newRoomData,
  //     rateplans: [
  //       ...newRoomData.rateplans.map((singleRatePlan) => ({
  //         ...singleRatePlan
  //       }))
  //     ]
  //   })
  // }
  const onClickRatePlans = () => {
    getChannelInventoryData({
      variables: {
        input: {
          ...getInventoryInput,
          roomTypeCode: roomtypeCode,
          providerCode: providerData.basicDetails.providerCode
        }
      }
    })
  }
  useEffect(() => {
    setshowRatePlans(false)
  }, [range])

  useEffect(() => {
    if (showRatePlans) {
      onClickRatePlans()
    }
  }, [showRatePlans])

  return (
    <Paper className={classes.paper} elevation={5}>
      <div>
        <InventoryProviderRow
          name={`${providerData?.basicDetails.name} (${providerData.basicDetails.displayProviderCode})`}
          availability={providerData?.dataForEachDate.map((date) => ({
            date: date.date,
            value: date.availability.value,
            manual: date.availability.manual
          }))}
          providerData={providerData?.dataForEachDate || []}
          numberOfRatePlans={providerData?.basicDetails.ratePlans.length}
          loadingForRatePlans={channelInventoryLoading}
          handleChangeSelectedInventoryFieldInProvider={
            handleChangeSelectedInventoryFieldInProvider
          }
          providerCode={providerData.basicDetails.providerCode}
          propertyCode={getInventoryInput.propertyCode}
          {...{
            selectedInventoryFieldInProvider,
            showRatePlans,
            setshowRatePlans,
            weekendIndexes,
            numberOfRooms,
            range,
            refreshInventory,
            roomtypeCode
          }}
        />
        <Collapse in={showRatePlans}>
          <div>
            <InfiniteScroll
              pageStart={0}
              loadMore={() => {
                setTimeout(() => {
                  setnumberOfVisibleRatePlans(
                    numberOfVisibleRatePlans + PAGE_SIZE
                  )
                }, 500)
              }}
              hasMore={
                providerData &&
                numberOfVisibleRatePlans <
                  providerData.basicDetails.ratePlans.length - 1
              }
              loader={
                <div key={0} className={classes.loadingContainer}>
                  <CircularProgress size={32} />
                </div>
              }
              useWindow={true}>
              {!channelInventoryLoading &&
                providerData?.basicDetails.ratePlans
                  .slice(0, numberOfVisibleRatePlans)
                  .map((ratePlanItem, index) => (
                    <InventoryRatePlanRow
                      key={index}
                      roomName={providerData?.basicDetails.name}
                      ratePlanData={ratePlanItem?.dataForEachDate}
                      availability={providerData?.dataForEachDate.map(
                        (date) => ({
                          date: date.date,
                          value: date.availability.value,
                          manual: date.availability.manual
                        })
                      )}
                      ratePlanName={`${ratePlanItem?.basicDetails.name} (${ratePlanItem.basicDetails.displayRatePlanCode})`}
                      displayRatePlanCode={
                        ratePlanItem.basicDetails.displayRatePlanCode
                      }
                      {...{
                        range,
                        channels,
                        occupancy,
                        defaultOccupancy,
                        hideZeroes,
                        weekendIndexes,
                        selectedInventoryFieldInRatePlan,
                        handleChangeSelectedInventoryFieldInRatePlan,
                        selectedInventoryFieldInChannel,
                        handleChangeSelectedInventoryFieldInChannel
                      }}
                      channelsData={
                        channelInventoryData?.channelInventory || []
                      }
                      addOns={providerData.basicDetails.addOns}
                      // onSaveRowData={(newRowData) =>
                      //   handleChangeRatePlanRowData(newRowData, index)
                      // }
                      // onCopyRatePlanForOtherRatePlans={
                      //   () => {
                      //     setratePlanSelectionModalIsOpen(true)
                      //     setselectedRatePlanIndex(index)
                      //   }
                      // handleCopyRatePlanRowForOtherRatePlans(index)
                      // }
                    />
                  ))}
            </InfiniteScroll>
          </div>
        </Collapse>
      </div>
      {/* {ratePlanSelectionModalIsOpen && (
        <InventoryRatePlanSelectionModal
          onClose={() => setratePlanSelectionModalIsOpen(false)}
          onConfirm={(selectedRatePlans) => {
            setratePlanSelectionModalIsOpen(false)
            handleCopyRatePlanRowForOtherRatePlans(
              selectedRatePlanIndex,
              selectedRatePlans
            )
          }}
          ratePlans={providerData.rateplans
            .filter((item, index) => index !== selectedRatePlanIndex)
            .map((item) => item.name)}
        />
      )} */}
    </Paper>
  )
}

export default InventoryProviderBox
